// extracted by mini-css-extract-plugin
module.exports = {"swiper":"slider_swiper__3vpl9","fadeIn":"slider_fadeIn__3Jva6","swiper-slide":"slider_swiper-slide__U-GiM","active":"slider_active__2bovn"};